/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';

export interface ArbitratorBulkActionRequest {
  bulk: BulkSelection;
  min_score?: number | null;
  q?: string | null;
}
